import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCheckCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	"aria-hidden": "true",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14.4516C4.43444 14.4516 1.54839 11.5661 1.54839 8C1.54839 4.43444 4.43391 1.54839 8 1.54839C11.5656 1.54839 14.4516 4.43391 14.4516 8C14.4516 11.5656 11.5661 14.4516 8 14.4516ZM12.5205 6.29801L6.95316 11.8207C6.80138 11.9713 6.55629 11.9703 6.40575 11.8185L3.47732 8.8664C3.32674 8.71459 3.32775 8.46947 3.47952 8.31893L4.21239 7.59195C4.36416 7.44141 4.60925 7.44241 4.7598 7.59419L6.68857 9.53862L11.2483 5.01553C11.4001 4.86495 11.6452 4.86593 11.7957 5.0177L12.5227 5.75054C12.6733 5.90231 12.6723 6.14743 12.5205 6.29801Z",
		fill: "#d6d6d6"
	})]
});
const ForwardRef = forwardRef(SvgIconCheckCircle);
export { ForwardRef as ReactComponent };
